import {
  UUID,
  CreatedAt,
  FetchItemsSort,
  FetchItemsPage,
  FetchItemsLimit,
  FetchItemsGqlQuery,
  FetchItemsCacheKey,
  ID,
  DateType,
  IdFilterType
} from '../../types';

import {
  UserUUID,
  UserFullName,
  UserImageFile,
  UserImageUUID,
  UserID,
  UserNanoID,
  UserClient,
  UserCurrentTeamNanoID
} from '../users/usersTypes';

export type DeepArchiveRestoreRequestID = ID;
export type DeepArchiveRestoreRequestUUID = UUID;
export type DeepArchiveRestoreRequestCreatedAt = CreatedAt;
export type DeepArchiveRestoreRequestEstimatedReadyAt = DateType | null;
export type DeepArchiveRestoreRequestArgumentsSize = number;
export type DeepArchiveRestoreRequestBacktrace = string;
export type DeepArchiveRestoreRequestDeepArchiveRestoreRequestType =
  DeepArchiveRestoreRequestDeepArchiveRestoreRequestTypesEnum;
export type DeepArchiveRestoreRequestErrorMessage = string;
export type DeepArchiveRestoreRequestProgress = number;
export type DeepArchiveRestoreRequestStatus =
  DeepArchiveRestoreRequestStatusesEnum;
export type DeepArchiveRestoreRequestType = string;

export type DeepArchiveRestoreRequestUserID = UserID;
export type DeepArchiveRestoreRequestUserUUID = UserUUID;
export type DeepArchiveRestoreRequestUserNanoID = UserNanoID;
export type DeepArchiveRestoreRequestUserFullName = UserFullName;
export type DeepArchiveRestoreRequestUserImageUUID = UserImageUUID;
export type DeepArchiveRestoreRequestUserImageFile = UserImageFile;
export type DeepArchiveRestoreRequestUserClient = UserClient;
export type DeepArchiveRestoreRequestUserCurrentTeamNanoID =
  UserCurrentTeamNanoID;

export interface FetchDeepArchiveRestoreRequestsFilters {
  taskId?: IdFilterType;
  fileAttachmentId?: ID;
}
export enum DeepArchiveRestoreRequestStatusesEnum {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  READY = 'ready',
  EXPIRED = 'expired',
  SKIPPED = 'skipped'
}

export enum DeepArchiveRestoreRequestDeepArchiveRestoreRequestTypesEnum {
  BATCH_TASK_CREATION = 'batch_task_creation',
  MULTIPLE_TASK_CREATION = 'multiple_task_creation',
  BATCH_ALLOCATE_FUNDS = 'batch_allocate_funds',
  BATCH_TRANSACTIONS_IMPORT = 'batch_transactions_import',
  BATCH_USERS_PAYONEER_IDS_IMPORT = 'batch_users_payoneer_ids_import',
  BATCH_REVENUE_SHARE_ITEMS_IMPORT = 'batch_revenue_share_items_import',
  BATCH_USERS_PAYONEER_IDS_PE_IMPORT = 'batch_users_payoneer_ids_pe_import',
  BATCH_REVENUE_SHARES_IMPORT = 'batch_revenue_shares_import'
}

export enum FetchDeepArchiveRestoreRequestsSortableFields {
  ID = 'id',
  CREATED_AT = 'createdAt'
}

export enum FetchDeepArchiveRestoreRequestsSortTypes {
  CREATED_AT_DESC = 'CREATED_AT_DESC'
}

export type FetchDeepArchiveRestoreRequestsPage = FetchItemsPage;
export type FetchDeepArchiveRestoreRequestsLimit = FetchItemsLimit;
export type FetchDeepArchiveRestoreRequestsSort = FetchItemsSort;

export type FetchDeepArchiveRestoreRequestsGqlQuery = FetchItemsGqlQuery;

export type FetchDeepArchiveRestoreRequestsCacheKey = FetchItemsCacheKey;
